import { APP_CONSTANTS } from 'src/app/constants/constants';
import {
	HttpClient,
	HttpHeaders,
	HttpEvent,
	HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '../storage/storage.service';

@Injectable({
	providedIn: 'root',
})
export class CommonService {

  APP_CONSTANTS = APP_CONSTANTS;

	// baseUrl = environment.apiEndpoint;
	baseUrl = "";
	user_details: any;
	//httpOptions;

	common_url: any = environment.apiEndpoint;
	deposit_growth_url: any = environment.apiEndpoint + "/deposits";
	lending_growth_url: any = environment.apiEndpoint + "/lending";
	insurance_growth_url: any = environment.apiEndpoint + "/insurance";

	constructor(
		private http: HttpClient,
		private toaster: ToastrService,
		private storageService: StorageService,
	) {
		this.user_details = this.storageService.get("user_details");
		// if (this.user_details) {

		// 	if (
		// 		this.user_details.role.role == 4 ||
		// 		this.user_details.role.role == 5 ||
		// 		this.user_details.role.role == 6 ||
		// 		this.user_details.role.role == 7 ||
		// 		this.user_details.role.role == 8
		// 	) {
		// 		if (this.user_details.role.business_area[0] == 5) {
		// 			this.baseUrl = this.common_url;
		// 		} else if (this.user_details.role.business_area[0] == 6) {
		// 			this.baseUrl = this.deposit_growth_url;
		// 		} else if (this.user_details.role.business_area[0] == 7) {
		// 			this.baseUrl = this.lending_growth_url;
		// 		} else if (this.user_details.role.business_area[0] == 8) {
		// 			this.baseUrl = this.insurance_growth_url;
		// 		}

		// 	} else {
		// 		this.baseUrl = this.common_url;
		// 	}
		// } else {
		// 	this.baseUrl = this.common_url;
		// }
    this.setBaseUrl()
	}

  setBaseUrl(){
    this.user_details = this.storageService.get("user_details");
    if (this.user_details) {

			if (
				this.user_details.role.role == 4 ||
				this.user_details.role.role == 5 ||
				this.user_details.role.role == 6 ||
				this.user_details.role.role == 7 ||
				this.user_details.role.role == 8 ||
				this.user_details.role.role == 12 ||
				this.user_details.role.role == 13 ||
				this.user_details.role.role == 14
			) {
				if (this.user_details.role.business_area[0] == 5) {
					this.baseUrl = this.common_url;
				} else if (this.user_details.role.business_area[0] == 6) {
					this.baseUrl = this.deposit_growth_url;
				} else if (this.user_details.role.business_area[0] == 7) {
					this.baseUrl = this.lending_growth_url;
				} else if (this.user_details.role.business_area[0] == 8) {
					this.baseUrl = this.insurance_growth_url;
				}

			} else {
				this.baseUrl = this.common_url;
			}
		} else {
			this.baseUrl = this.common_url;
		}
  }

	getData(url) {
		return this.http.get(this.baseUrl + url);
	}
	getSingleData(url, id) {
		return this.http.get(this.baseUrl + url + id);
	}
	postData(url, obj) {
		return this.http.post(this.baseUrl + url, obj);
	}
	deleteData(url) {
		return this.http.delete(this.baseUrl + url);
	}
	updateData(url, obj) {
		return this.http.put(this.baseUrl + url, obj);
	}
	put(url, obj) {
		return this.http.put(this.baseUrl + url, obj);
	}
	patch(url, obj) {
		return this.http.patch(this.baseUrl + url, obj);
	}
	delete(url) {
		return this.http.delete(this.baseUrl + url);
	}

	saveToLocalStorage(key, value) {
		return localStorage.setItem(key, value);
	}

	getFromLocalStorage(key) {
		return localStorage.getItem(key);
	}

	showToaster(type, msg) {
		if (typeof msg == 'undefined') msg = 'Something Went Wrong';
		if (type == 'error') {
			this.toaster.error(
				'<span data-notify="icon"></span><span data-notify="message"><b>Error</b> - ' +
				msg +
				'</span>',
				'',
				{
					timeOut: 5000,
					enableHtml: true,
					closeButton: true,
					toastClass: 'alert alert-danger alert-with-icon',
					positionClass: 'toast-' + 'top' + '-' + 'right',
				},
			);
		} else if (type == 'success') {
			this.toaster.success(
				'<span data-notify="icon" ></span><span data-notify="message"><b>Message</b> - ' +
				msg +
				'</span>',
				'',
				{
					timeOut: 5000,
					enableHtml: true,
					closeButton: true,
					toastClass: 'alert alert-success alert-with-icon',
					positionClass: 'toast-' + 'top' + '-' + 'right',
				},
			);
		} else if (type == 'warning') {
			this.toaster.warning(
				'<span data-notify="icon" ></span><span data-notify="message"><b>Message</b> - ' +
				msg +
				'</span>',
				'',
				{
					timeOut: 5000,
					enableHtml: true,
					closeButton: true,
					toastClass: 'alert alert-warning alert-with-icon',
					positionClass: 'toast-' + 'top' + '-' + 'right',
				},
			);
		} else if (type == 'info') {
			this.toaster.info(
				'<span data-notify="icon" ></span><span data-notify="message"><b>Message</b> - ' +
				msg +
				'</span>',
				'',
				{
					timeOut: 5000,
					enableHtml: true,
					closeButton: true,
					toastClass: 'alert alert-info alert-with-icon',
					positionClass: 'toast-' + 'top' + '-' + 'right',
				},
			);
		}
	}

	businessPlanUrl = this.baseUrl + '/businessPlan?no_page=true';
	addNewBPUrl = this.baseUrl + '/businessPlan';
	deleteBPUrl = this.baseUrl + '/businessPlan/destroy?ids=';
	deleteInitiativeUrl = this.baseUrl + '/businessPlanInitiative/destroy?ids=';
	updateBPUrl = this.baseUrl + '/businessPlan';
	updateBPINitiativeURL = this.baseUrl + '/businessPlanInitiative';
	addNewINtiative = this.baseUrl + '/businessPlanInitiative';
	downloadBPIFileUrl = this.baseUrl + '/get/attachment?id=';

	//Sales cycle Urls

	salesCycleUrl = this.baseUrl + '/salesCycle';
	addsalseCycleURL = this.baseUrl + '/salesCycle';
	productManegersUrl = this.baseUrl + '/user?no_page=true';
	deleteSalesCycleUrl = this.baseUrl + '/salesCycle/destroy?ids=';
	updateSalseCycleUrl = this.baseUrl + '/salesCycle';
	deleteproduct = this.baseUrl + '/salesCycleProduct/destroy?ids=';
	updateProduct = this.baseUrl + '/salesCycleProduct/';
	createProductINexstingURl = this.baseUrl + '/salesCycleProduct';
	// marketing compains urls

	marketingCompaignsURL = this.baseUrl + '/campaign';
	addmarketingCompaignsURL = this.baseUrl + '/campaign';
	deletemarketingCompaignsUrl = this.baseUrl + '/campaign/destroy?ids=';

	// channel urls
	channelURL = this.baseUrl + '/communicationType';

	// product urls
	productURL = this.baseUrl + '/product';

	// userUrls
	userUrl = this.baseUrl + '/user?no_page=true';
	userRols = this.baseUrl + '/group?no_page=true';
	addNewUserUrl = this.baseUrl + '/user';
	getListOfAMUrl = this.baseUrl + '/userGroup?group=3&latest=true&no_page=true';
	getListOFMMURL = this.baseUrl + '/userGroup?group=2&latest=true&no_page=true';
	gerReportToWiseResions = this.baseUrl + '/region?user_groups__id=';
	addNewRoleUrl = this.baseUrl + '/userGroup';
	updateUserUrl = this.baseUrl + '/user/';
	updateRoleUrl = this.baseUrl + '/userGroup/';
	roleUrl = this.baseUrl + '/group?no_page=true';
	deleteRoleUrl = this.baseUrl + '/userGroup/destroy?ids=';
	deleteUserUrl = this.baseUrl + '/user/destroy?ids=';
	productGroupUrl = this.baseUrl + '/productGroup';
	emailUrl = this.baseUrl + '/emailTemplate';
	regionUrl = this.baseUrl + '/region';
	statusTriggerUrl = this.baseUrl + '/statusTrigger';
	countryUrl = this.baseUrl + '/country';
	salesPlanUrl = this.baseUrl + '/salesPlan';
	salesPlanTaskTemplateUrl = this.baseUrl + '/salesPlanTaskTemplate';
	deletesalesPlanTaskTemplateUrl =
	this.baseUrl + '/salesPlanTaskTemplate/destroy?ids=';
	deletesalesPlanUrl = this.baseUrl + '/salesPlan/destroy?ids=';
	addNewSalesPlanTaskTemplateUrl = this.baseUrl + '/salesPlanTaskTemplate';

	addNewSalesPlan(data) {
		return this.http.post(this.salesPlanUrl, data);
	}
	getSalesPlan() {
		return this.http.get(this.salesPlanUrl);
	}
	updateSalesPlan(id, data) {
		return this.http.patch(this.salesPlanUrl + '/' + id, data);
	}
	addNewSalesPlanTaskTemplate(data) {
		return this.http.post(this.addNewSalesPlanTaskTemplateUrl, data);
	}
	updateSalesPlanTaskTemplate(id, data) {
		return this.http.patch(this.salesPlanTaskTemplateUrl + '/' + id, data);
	}
	deleteSalesPlan(data) {
		return this.http.delete(this.deletesalesPlanUrl + data);
	}
	deleteSalesPlanTaskTemplate(data) {
		return this.http.delete(this.deletesalesPlanTaskTemplateUrl + data);
	}
	getCountry() {
		return this.http.get(this.countryUrl);
	}
	getStatusTrigger() {
		return this.http.get(this.statusTriggerUrl);
	}
	getRegion() {
		return this.http.get(this.regionUrl);
	}
	getEmail() {
		return this.http.get(this.emailUrl);
	}
	productGroup() {
		return this.http.get(this.productGroupUrl);
	}
	userService() {
		return this.http.get(this.userUrl);
	}

	userRolesService() {
		return this.http.get(this.userRols);
	}
	addNewUser(user) {
		return this.http.post(this.userUrl, user);
	}
	addNewRoleService(role) {
		return this.http.post(this.addNewRoleUrl, role);
	}
	advisorMList() {
		return this.http.get(this.getListOfAMUrl);
	}
	marketingMList() {
		return this.http.get(this.getListOFMMURL);
	}
	getReportToWiseResion(id) {
		return this.http.get(this.gerReportToWiseResions + id + '&no_page=true');
	}
	updateUser(updatedUserValue, id) {
		return this.http.patch(this.updateUserUrl + id, updatedUserValue);
	}
	getRole() {
		return this.http.get(this.roleUrl);
	}
	updateRoles(id, updatedRoleData) {
		return this.http.patch(this.updateRoleUrl + id, updatedRoleData);
	}
	deleteRoles(id) {
		return this.http.delete(this.deleteRoleUrl + id);
	}
	deleteUser(id) {
		return this.http.delete(this.deleteUserUrl + id);
	}

	//
	activeBusinessPlanUrl: any =
	this.baseUrl + '/activeBusinessPlan?no_page=true';
	getActiveBusinessPlans() {
		return this.http.get(this.activeBusinessPlanUrl);
	}

	activeSalesCycleUrl: any = this.baseUrl + '/activeSalesCycle?no_page=true';
	getActiveSalesCycles() {
		return this.http.get(this.activeSalesCycleUrl);
	}

	// businessPlan service funtions start

	businessPlanService() {
		return this.http.get(this.businessPlanUrl);
	}
	addNewBusinessPlan(data) {
		return this.http.post(this.addNewBPUrl, data);
	}
	updateBP(data) {
		let id = data.id;
		return this.http.patch(this.updateBPUrl + '/' + id, data);
	}
	updateBPInitiative(ids, data) {
		let id = data.initiative_id;
		if (ids == '') {
			return this.http.patch(this.updateBPINitiativeURL + '/' + id, data);
		}
		if (ids) {
			return this.http.patch(this.updateBPINitiativeURL + '/' + ids, data);
		}
	}
	downloadBPIfile(id) {
		return this.http.get(this.downloadBPIFileUrl + id);
	}
	addNewInitiative(data) {
		return this.http.post(this.addNewINtiative, data);
	}
	deleteBP(id) {
		return this.http.delete(this.deleteBPUrl + id);
	}
	deleteBPINitiatives(id) {
		return this.http.delete(this.deleteInitiativeUrl + id);
	}

	// salse cycle services
	getSalescycleList() {
		return this.http.get(this.salesCycleUrl);
	}
	productManagers() {
		return this.http.get(this.productManegersUrl);
	}
	deleteSalesCycle(data) {
		return this.http.delete(this.deleteSalesCycleUrl + data);
	}
	addnewSaleseCycles(data) {
		return this.http.post(this.addsalseCycleURL, data);
	}
	getlistOfPMs() {
		return this.http.get(this.productManegersUrl);
	}
	updateSalesCycle(id, data) {
		return this.http.patch(this.updateSalseCycleUrl + '/' + id, data);
	}
	deleteProduct(ids) {
		return this.http.delete(this.deleteproduct + ids);
	}
	updateSalesCycleProduct(id, data) {
		return this.http.patch(this.updateProduct + id, data);
	}
	createProductInExisting(data) {
		return this.http.post(this.createProductINexstingURl, data);
	}

	// marketing compaigns servises

	getMarketingCOmpaigns() {
		return this.http.get(this.marketingCompaignsURL);
	}

	addnewmarketingCompaign(data) {
		return this.http.post(this.addmarketingCompaignsURL, data);
	}

	updateMarketingCampaign(id, data) {
		return this.http.patch(this.marketingCompaignsURL + '/' + id, data);
	}

	deletemarketingCompaign(data) {
		return this.http.delete(this.deletemarketingCompaignsUrl + data);
	}

	// channel service
	getChannel() {
		return this.http.get(this.channelURL);
	}

	// product services
	getProducts() {
		return this.http.get(this.productURL);
	}

	abbreviateNumberUSA(value) {
		let fixed = 1;
		let num = value;
		if (num === null) {
			return null;
		}
		if (num === 0) {
			return '0';
		}
		fixed = !fixed || fixed < 0 ? 0 : fixed;
		var b = num.toPrecision(2).split('e'),
		k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
		c =
		k < 1
		? num.toFixed(0 + fixed)
		: (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
		d = c < 0 ? c : Math.abs(c),
		e = d + ['', 'K', 'M', 'B', 'T'][k];
		return e;

		// value = Math.round(value);
		// let new_value = value;
		// if (value >= 1000) {
		//     const suffixes = ["", "K", "M", "B","T"];
		//     const suffixNum = Math.floor( (""+value).length/3 );
		//     let shortValue: any = '';
		//     for (var precision = 2; precision >= 1; precision--) {
		//         shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
		//         var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
		//         if (dotLessShortValue.length <= 2) { break; }
		//     }
		//     if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
		//     new_value = shortValue+suffixes[suffixNum];
		// }
		// return new_value;
	}

  // abbreviateNumber(value: number) {
  //   let num = value;

  //   if (num === null) return null;
  //   if (num === 0) return '0';

  //   if (APP_CONSTANTS.COUNTRY == 'USA') {
  //     let fixed = 1;
  //     fixed = !fixed || fixed < 0 ? 0 : fixed;

  //     let b = num.toPrecision(2).split('e'),
  //       k = b.length === 1 ? 0 : Math.floor(Math.min(+b[1].slice(1), 14) / 3),
  //       c: any =
  //         k < 1
  //           ? num.toFixed(0 + fixed)
  //           : (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
  //       d = c < 0 ? c : Math.abs(+c),
  //       e = d + ['', 'K', 'M', 'B', 'T'][k];

  //     return e;
  //   } else if (APP_CONSTANTS.COUNTRY == 'India') {
  //     let absNum = Math.abs(num);

  //     if (absNum < 1000) {
  //       return num.toString();
  //     }
  //     else if (absNum < 100000) {
  //       // Thousand
  //       return (num / 1000).toFixed(1) + 'K';
  //     }
  //     else if (absNum < 10000000) {
  //       // Lakh (1,00,000)
  //       return (num / 100000).toFixed(1) + 'L';
  //     }
  //     else {
  //       // Crore (1,00,00,000)
  //       return (num / 10000000).toFixed(1) + 'Cr';
  //     }
  //   }
  // }

  abbreviateNumber(value: number) {
    let num = value;

    if (num === null) return null;
    if (num === 0) return '0';

    if (APP_CONSTANTS.COUNTRY == 'USA') {
      let fixed = 1;
      fixed = !fixed || fixed < 0 ? 0 : fixed;

      let b = num.toPrecision(2).split('e'),
        k = b.length === 1 ? 0 : Math.floor(Math.min(+b[1].slice(1), 14) / 3),
        c: any =
          k < 1
            ? num.toFixed(0 + fixed)
            : (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
        d = c < 0 ? c : Math.abs(+c),
        e = d + ['', 'K', 'M', 'B', 'T'][k];

      return e;

    } else if (APP_CONSTANTS.COUNTRY == 'India') {
      let absNum = Math.abs(num);
      let result: number;
      let suffix = '';

      if (absNum < 1000) {
        return num.toString();
      }
      else if (absNum < 100000) {
        result = num / 1000;
        suffix = 'K';
      }
      else if (absNum < 10000000) {
        result = num / 100000;
        suffix = 'L';
      }
      else {
        result = num / 10000000;
        suffix = 'Cr';
      }

      // ✅ Apply Indian comma formatting
      return Number(result.toFixed(1)).toLocaleString('en-IN') + ' ' + suffix;
    }
  }

  // labelFormatter(value) {
  //   let val: number = Math.abs(value);
  //   if (APP_CONSTANTS.COUNTRY == 'USA') {
  //     if (val >= 1e9) {
  //     return (val / 1e9).toFixed(1) + 'B'; // Billion
  //   } else if (val >= 1e6) {
  //     return (val / 1e6).toFixed(1) + 'M'; // Million
  //   } else if (val >= 1e3) {
  //     return (val / 1e3).toFixed(1) + 'K'; // Thousand
  //   }
  //   } else if (APP_CONSTANTS.COUNTRY == 'India') {
  //     if (val >= 1e7) {
  //     return (val / 1e7).toFixed(1) + 'Cr'; // Crore
  //   } else if (val >= 1e5) {
  //     return (val / 1e5).toFixed(1) + 'L'; // Lakh
  //   } else if (val >= 1e3) {
  //     return (val / 1e3).toFixed(1) + 'K'; // Thousand
  //   }
  //   } else {
  //     return value;
  //   }
  // }

  labelFormatter(value) {
    let val: number = Math.abs(value);

    if (APP_CONSTANTS.COUNTRY == 'USA') {
      let result: number;
      let suffix = '';

      if (val >= 1e9) {
        result = val / 1e9;
        suffix = 'B';
      } else if (val >= 1e6) {
        result = val / 1e6;
        suffix = 'M';
      } else if (val >= 1e3) {
        result = val / 1e3;
        suffix = 'K';
      } else {
        return value.toString();
      }

      return Number(result.toFixed(1)).toLocaleString('en-US') + ' ' + suffix;

    } else if (APP_CONSTANTS.COUNTRY == 'India') {
      let result: number;
      let suffix = '';

      if (val >= 1e7) {
        result = val / 1e7;
        suffix = 'Cr';
      } else if (val >= 1e5) {
        result = val / 1e5;
        suffix = 'L';
      } else if (val >= 1e3) {
        result = val / 1e3;
        suffix = 'K';
      } else {
        return value.toString();
      }

      // ✅ Indian comma format
      return Number(result.toFixed(1)).toLocaleString('en-IN') + ' ' + suffix;

    } else {
      return value;
    }
  }

	wholesalersList =
	this.baseUrl + '/userGroup?group=4&latest=true&no_page=true';

	ListofWholesalers() {
		return this.http.get(this.wholesalersList);
	}

	getBarGraphPercentWidth(chart_width, labels_count, bar_size) {
		const percentWidth = Math.round(
			(bar_size / (chart_width / labels_count)) * 100,
		);
		return `${percentWidth}%`;
	}


	toasts: any = [];

	showToast(type, message): void {
		const toast = {
			type: type,
			message: message,
		};
		this.toasts.push(toast);
		setTimeout(() => this.removeToast(0), 3000); // auto-remove toast after 3 seconds
	}

	removeToast(index: number): void {
		this.toasts.splice(index, 1);
	}

	// showSuccess(message): void {
	//   this.showToast('success' message);
	// }

	// showError(message): void {
	//   this.showToast('error', message);
	// }

	// showInfo(message): void {
	//   this.showToast('info', message);
	// }

	// showWarning(message): void {
	//   this.showToast('warning', message);
	// }

	formatNumberWithCommas(value) {
		return new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);
	}

}
